import { useTheme } from '@material-ui/core/styles';
import { BiError } from 'react-icons/bi';
import { lighten } from 'polished';

import { Card, ICardsProps } from '../../../../components/Card';
import { useSettings } from '../../../../hooks/settings';

export const OrdersWithOccurrenceCard = (
  props: Pick<ICardsProps, 'content' | 'percentage' | 'loading' | 'onClick'>
) => {
  const theme = useTheme();
  const { cardsLoading } = useSettings();

  return (
    <Card
      title="Ocorrências"
      invertPercentageColors
      icon={<BiError />}
      cardColor={lighten(0.325, theme.palette.error.main)}
      loading={cardsLoading}
      {...props}
    />
  );
};
